import { ParsedUrlQuery } from "querystring";

import getOrganization from "@/api/requests/consumerApi/getOrganization";

export async function getOrganizationData(query: ParsedUrlQuery) {
  const locations = query?.location?.[0];
  const organizationSlug = query?.location?.[1];
  return locations === "locations" && organizationSlug
    ? await getOrganization(organizationSlug)
    : null;
}
